import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=11c56c78&scoped=true"
import script from "./issue.vue?vue&type=script&lang=js"
export * from "./issue.vue?vue&type=script&lang=js"
import style0 from "./issue.vue?vue&type=style&index=0&id=11c56c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c56c78",
  null
  
)

export default component.exports